class TimeoutIdlePromiseError extends Error {
  code?: string;
}

class TimeoutError extends TimeoutIdlePromiseError {
  code = 'TIMEOUT_ERROR';
}

const timeoutIdlePromise = async (promiseFactory: () => Promise<any>, maximumIdleTime: number) => {
  return new Promise(async (resolve, reject) => {
    const Timeout: Object = setTimeout(() => {
      reject(new TimeoutError('Idle promise timeout.'));
    }, maximumIdleTime);
    try {
      const result = await promiseFactory();
      clearTimeout(Timeout as any);
      resolve(result);
    } catch (error) {
      reject(error);
    }
  });
};

export { TimeoutError, timeoutIdlePromise };
